import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

const HomeView = () => {
    const navigate = useNavigate(); // Hook for navigation

    // Function to navigate to the form page
    const handleNavigateToForm = () => {
        navigate('/form'); // Navigate to the /form route
    };

    return (
        <section id="home" className="header relative pt-16 items-center flex flex-col md:flex-row h-screen max-h-860-px">
            {/* Image Container - Top on Mobile, Right on Desktop */}
            <div className="w-full md:w-4/12 lg:w-6/12 xl:w-6/12 px-4 order-1">
                <img
                    className="w-full h-auto max-h-860px"
                    src={require("assets/img/sofiaHome.jpg")}
                    alt="Sofia Home"
                />
            </div>

            {/* Text Container - Below Image on Mobile, Left on Desktop */}
            <div className="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4 order-2 md:order-1">
                <div className="pt-8 md:pt-32">
                    <h2 className="font-semibold text-4xl text-blueGray-600">
                        Sofia: Your Destination for Perfect Proofreading and Editing
                    </h2>
                    <br />
                    <h4 className="text-lg text-blueGray-500">
                        Welcome to Sofia, where we transform your writing into clear, concise, and compelling content. We specialize in manuscript editing for academics, researchers, authors, and professionals, to ensure that your work is ready for publication, submission, or presentation.
                    </h4>
                    <br />
                    {/* Button to navigate to the form page */}
                    <button
                        onClick={handleNavigateToForm}
                        style={{
                            backgroundColor: 'black', // blue color
                            border: '1px solid black', // darker blue border
                            color: '#ffffff', // white text
                        }}
                        className="font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Go to Form
                    </button>
                </div>
            </div>
        </section>
    );
};

export default HomeView;

// import React from 'react';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

// const HomeView = () => {
//     const navigate = useNavigate(); // Hook for navigation

//     // Function to navigate to the form page
//     const handleNavigateToForm = () => {
//         navigate('/form'); // Navigate to the /form route
//     };

//     return (
//         <section id="home" className="header relative pt-16 items-center flex h-screen max-h-860-px">
//             <div className="container mx-auto items-center flex flex-wrap">
//                 <div className="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
//                     <div className="pt-32 sm:pt-0">
//                         <h2 className="font-semibold text-4xl text-blueGray-600">
//                             Sofia: Your Destination for Perfect Proofreading and Editing
//                         </h2>
//                         <br />
//                         <h4>
//                             Welcome to Sofia, where we transform your writing into clear, concise, and compelling content. We specialize in manuscript editing for academics, researchers, authors, and professionals, to ensure that your work is ready for publication, submission, or presentation.
//                         </h4>
//                         <br />
//                         {/* Button to navigate to the form page */}
//                         <button
//     onClick={handleNavigateToForm}
//     style={{
//         backgroundColor: 'black', // blue color
//         border: '1px solid black', // darker blue border
//         // backgroundColor: '#3498db', // blue color
//         // border: '1px solid #2980b9', // darker blue border
//         color: '#ffffff', // white text
//     }}
//     className="font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
// >
//     Go to Form
// </button>


//                     </div>
//                 </div>
//             </div>
//             <img
//                 className="absolute top-0 b-auto right-0 pt-16 sm:w-6/12 -mt-48 sm:mt-0 w-10/12 max-h-860px"
//                 src={require("assets/img/sofiaHome.jpg")}
//                 alt="..."
//             />
//         </section>
//     );
// };

// export default HomeView;